module.exports = __webpack_public_path__ + "static/media/PM110.948a76c5.png";